import { FC, useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Textarea } from 'core-components/library/inputs'

import { LOCATIONS_SEPARATOR } from '../../../../../../configs'
import { TRANSLATION_KEYS } from '../../../../translations'
import { BACK_SLASH_N_REGEXP, MULTIPLE_SPACE_REGEXP } from '../../configs'

import styles from './FormLocationsTextarea.module.scss'

interface ILocationsTextareaProps {
  onAddNewLocations: (locations: string[]) => void
}

export const FormLocationsTextarea: FC<ILocationsTextareaProps> = ({ onAddNewLocations }) => {
  const [textareaValue, setTextareaValue] = useState('')

  const handleAddNewLocations = useCallback(() => {
    const newLocations = textareaValue
      .replace(MULTIPLE_SPACE_REGEXP, ' ')
      .replace(BACK_SLASH_N_REGEXP, LOCATIONS_SEPARATOR)
      .split(LOCATIONS_SEPARATOR)
      .map((it) => it.trim())
      .filter((it) => it)

    onAddNewLocations(newLocations)
    setTextareaValue('')
  }, [textareaValue, onAddNewLocations])

  return (
    <div className={styles.formContainer}>
      <div className={styles.textAreaContainer}>
        <Textarea
          label={<Translation text={TRANSLATION_KEYS.locationsTextAreaPlaceholder} />}
          classes={{
            root: styles.textArea,
          }}
          rows={3}
          value={textareaValue}
          onChange={setTextareaValue}
        />
      </div>
      <div className={styles.addContainer}>
        <Button onClick={handleAddNewLocations}>
          <Translation text={TRANSLATION_KEYS.addButton} span />
        </Button>
      </div>
    </div>
  )
}
